import { z } from 'zod';

/**
 * Validates the SSE envelope shape ONLY — the discriminant plus the fields the
 * client branches on. `payload` (artifact) and `input` (tool_call) are left as
 * z.unknown() on purpose: they carry server-fetched data / model output, so
 * validating their internals would false-flag legitimate variety. The envelope
 * itself is authored deterministically by the server, so this catches contract
 * drift, not model creativity.
 */
export const turnStepEventSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('text'), content: z.string() }),
  z.object({ type: z.literal('status'), content: z.string() }),
  z.object({ type: z.literal('error'), content: z.string() }),
  z.object({
    type: z.literal('artifact'),
    id: z.string(),
    kind: z.enum(['filter_response', 'chart_config']),
    payload: z.unknown(),
  }),
  z.object({
    type: z.literal('tool_call'),
    id: z.string(),
    name: z.string(),
    input: z.unknown(),
  }),
  z.object({
    type: z.literal('tool_step'),
    name: z.string(),
    phase: z.enum(['start', 'end']),
    ok: z.boolean().optional(),
  }),
  z.object({ type: z.literal('done') }),
]);
